import React, { useEffect, useState } from "react";
import axios from "axios";

const Couponsdata = () => {
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const [formData, setFormData] = useState({
        code: "",
        discountAmount: "",
        isActive: true,
        customerId: "",
        usageType: "CAMPAIGN",
        usageLimit: "",
    });

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("authToken");

            const response = await axios.get(
                "https://backend.maamaas.com/promotions/api/admin/getall/coupons",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setCoupons(response.data || []);
        } catch (error) {
            console.error("Fetch Coupons Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleCreateCoupon = async () => {
        try {
            const token = localStorage.getItem("authToken");

            const payload = {
                code: formData.code,
                discountAmount: Number(formData.discountAmount),
                isActive: formData.isActive,
                customerId: formData.customerId,
                usageType: formData.usageType,
                usageLimit: Number(formData.usageLimit),
            };

            await axios.post(
                "https://backend.maamaas.com/promotions/api/admin/create/coupon",
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            alert("Coupon Created Successfully");

            setShowPopup(false);

            setFormData({
                code: "",
                discountAmount: "",
                isActive: true,
                customerId: "",
                usageType: "CAMPAIGN",
                usageLimit: "",
            });

            fetchCoupons();
        } catch (error) {
            console.error("Create Coupon Error:", error);
            alert("Failed to create coupon");
        }
    };

    return (
        <div style={containerStyle}>
            {/* Top Section */}
            <div style={topBarStyle}>


                <button
                    style={createButtonStyle}
                    onClick={() =>
                        setShowPopup(true)
                    }
                >
                    Create Coupon
                </button>
            </div>

            {/* Table */}
            <div style={tableWrapperStyle}>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>
                                Coupon Code
                            </th>
                            <th style={thStyle}>
                                Discount Amount
                            </th>
                            <th style={thStyle}>
                                Active
                            </th>
                            <th style={thStyle}>
                                Customer Id
                            </th>
                            <th style={thStyle}>
                                Usage Type
                            </th>
                            <th style={thStyle}>
                                Usage Limit
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {coupons.length > 0 ? (
                            coupons.map(
                                (
                                    item,
                                    index
                                ) => (
                                    <tr
                                        key={
                                            index
                                        }
                                    >
                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.code
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.discountAmount
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {item.isActive
                                                ? "Yes"
                                                : "No"}
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.customerId
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.usageType
                                            }
                                        </td>

                                        <td
                                            style={
                                                tdStyle
                                            }
                                        >
                                            {
                                                item.usageLimit
                                            }
                                        </td>
                                    </tr>
                                )
                            )
                        ) : (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{
                                        textAlign:
                                            "center",
                                        padding:
                                            "20px",
                                    }}
                                >
                                    {loading
                                        ? "Loading..."
                                        : "No Coupons Found"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Popup */}
            {showPopup && (
                <div style={overlayStyle}>
                    <div style={popupStyle}>
                        <h2
                            style={{
                                marginBottom:
                                    "20px",
                            }}
                        >
                            Create Coupon
                        </h2>

                        <div
                            style={
                                formGridStyle
                            }
                        >
                            {/* Code */}
                            <div>
                                <label
                                    style={
                                        labelStyle
                                    }
                                >
                                    Coupon
                                    Code
                                </label>

                                <input
                                    type="text"
                                    value={
                                        formData.code
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        handleChange(
                                            "code",
                                            e
                                                .target
                                                .value
                                        )
                                    }
                                    style={
                                        inputStyle
                                    }
                                />
                            </div>

                            {/* Discount */}
                            <div>
                                <label
                                    style={
                                        labelStyle
                                    }
                                >
                                    Discount
                                    Amount
                                </label>

                                <input
                                    type="number"
                                    value={
                                        formData.discountAmount
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        handleChange(
                                            "discountAmount",
                                            e
                                                .target
                                                .value
                                        )
                                    }
                                    style={
                                        inputStyle
                                    }
                                />
                            </div>

                            {/* Customer ID */}
                            <div>
                                <label
                                    style={
                                        labelStyle
                                    }
                                >
                                    Customer
                                    ID
                                </label>

                                <input
                                    type="text"
                                    value={
                                        formData.customerId
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        handleChange(
                                            "customerId",
                                            e
                                                .target
                                                .value
                                        )
                                    }
                                    style={
                                        inputStyle
                                    }
                                />
                            </div>

                            {/* Usage Type */}
                            <div>
                                <label
                                    style={
                                        labelStyle
                                    }
                                >
                                    Usage
                                    Type
                                </label>

                                <select
                                    value={
                                        formData.usageType
                                    }
                                    onChange={(e) =>
                                        handleChange(
                                            "usageType",
                                            e.target.value
                                        )
                                    }
                                    style={inputStyle}
                                >
                                    <option value="CAMPAIGN">
                                        CAMPAIGN
                                    </option>

                                    <option value="SUBSCRIPTION">
                                        SUBSCRIPTION
                                    </option>
                                </select>
                            </div>

                            {/* Usage Limit */}
                            <div>
                                <label
                                    style={
                                        labelStyle
                                    }
                                >
                                    Usage
                                    Limit
                                </label>

                                <input
                                    type="number"
                                    value={
                                        formData.usageLimit
                                    }
                                    onChange={(
                                        e
                                    ) =>
                                        handleChange(
                                            "usageLimit",
                                            e
                                                .target
                                                .value
                                        )
                                    }
                                    style={
                                        inputStyle
                                    }
                                />
                            </div>

                            {/* Active */}

                        </div>

                        {/* Buttons */}
                        <div
                            style={{
                                display:
                                    "flex",
                                justifyContent:
                                    "flex-end",
                                gap: "12px",
                                marginTop:
                                    "25px",
                            }}
                        >
                            <button
                                style={
                                    cancelButtonStyle
                                }
                                onClick={() =>
                                    setShowPopup(
                                        false
                                    )
                                }
                            >
                                Close
                            </button>

                            <button
                                style={
                                    saveButtonStyle
                                }
                                onClick={
                                    handleCreateCoupon
                                }
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const containerStyle = {
    padding: "20px",
    fontFamily:
        "Segoe UI, sans-serif",
};

const topBarStyle = {
    display: "flex",
    justifyContent:
        "space-between",
    alignItems: "center",
    marginBottom: "20px",
};

const createButtonStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "600",
};

const tableWrapperStyle = {
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: "10px",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
};

const thStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    padding: "14px",
    textAlign: "center",
    fontWeight: "600",
};

const tdStyle = {
    padding: "14px",
    textAlign: "center",
    borderBottom:
        "1px solid #ddd",
};

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
        "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999,
};

const popupStyle = {
    background: "#fff",
    width: "700px",
    borderRadius: "12px",
    padding: "25px",
};

const formGridStyle = {
    display: "grid",
    gridTemplateColumns:
        "repeat(2,1fr)",
    gap: "18px",
};

const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    fontSize: "14px",
};

const inputStyle = {
    width: "100%",
    padding: "12px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    outline: "none",
};

const saveButtonStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
};

const cancelButtonStyle = {
    background: "#6b7280",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
};

export default Couponsdata;